import * as React from "react";
import {cx} from "emotion";

import "./search-form.scss";

import {bindInput}          from "@Common/react/bind-input";
import {cs}                 from "@Common/react/chain-services";
import {Form2}              from "@Common/react/cs-form-2/form2";
import {required}           from "@Common/react/cs-form-2/validators/required";
import {fragments}          from "@Common/react/fragments";
import {keyCombo}           from "@Common/react/key-combo";
import {NumberInputBinding} from "@Common/react/number-input-binding";
import {scnv}               from "@Common/react/state-change-nested-value";
import {UseState}           from "@Common/react/use-state";
import {GlobalKeyDown2}     from "@Common/ui-components/browser/global-key-down-2";
import {isDevQuan}          from "@Common/ui-components/debug/is-dev-quan";
import {SliderCheckbox}     from "@Common/ui-components/slider-checkbox/slider-checkbox";
import {snv}                from "@Common/utils/arr-path";

import {InformationBadge} from "../../../../../../../common/design2/information-badge/information-badge";
import {Select}           from "../../../../../../../common/design2/select/select";

export const SearchForm = ({entityId, next}) => cs(
    ["data", (_, next) => UseState({
        getInitValue: () => ({
            addressType: "both",
            entityId,
            ...isDevQuan() && {
                // address: "1229 Wisconsin Avenue",
                // zip: "20007",
                // quantity: 55,
                address: "6103 station way DR",
                zip: "76131",
                quantity: 100,
            },
        }),
        next,
    })],

    ({data}) => next({
        resetForm: (d1) => data.onChange(d1),
        setAddress: (address) => {
            const newForm = snv(data.value, ["address"], address);
            data.onChange(newForm);
            return newForm;
        },
        render: ({onSearch, searching, className}) => cs(
            ["form", ({}, next) => Form2({
                data,
                fields: {
                    // 1115 forest park blvd
                    // 76110
                    "address"       : [required],
                    "zip"           : [required],
                    "addressType"   : [required],
                    "quantity"      : [
                        required,
                        {
                            name: "quantity",
                            validate: (quantity) => quantity > 0,
                        }
                    ],
                },
                onSubmit: () => onSearch(data.value),
                next,
            })],

            ({}, next) => fragments(
                next(),
                GlobalKeyDown2({
                    check: keyCombo("ctrl+F9"),
                    action: () => {
                        scnv(data, [], (_) => ({
                            ..._,
                            address: "321 Abercorn Street",
                            zip: "31401",
                            quantity: 50,
                        }))
                    },
                }),
            ),

            ({form}) => (
                <div className={cx("search-form-28j", className)}>
                    <div className="form-group address">
                        <div className="control-label" xd-qa-type="label" xd-qa-name="Build Radius List Property Address">
                            Property Address
                        </div>

                        {cs(
                            ["focus", (_, next) => UseState({next})],
                            ({focus}) => {
                                const field = form.field(["address"]);
                                return (
                                    <div {...{
                                        className: cx("input", {
                                            focus: focus.value,
                                            hasError: field.error,
                                        }),
                                    }}
                                    >
                                        <input {...{
                                            placeholder: "123 Some Street",
                                            onFocus: () => focus.onChange(true),
                                            onBlur: () => focus.onChange(false),
                                            ...bindInput(field.state),
                                            "xd-qa-type": "text_field",
                                            "xd-qa-name": "Build Radius List Property Address",
                                        }}/>

                                        {InformationBadge({
                                            getTooltip: () => (
                                                <ul className="message-5ww">
                                                    <li>Include the street address you wish to center your list around.</li>
                                                    <li>Omit periods following abbreviations.</li>
                                                    <li>Abbreviate the cardinal direction in a street name (i.e. S for South. NW for Northwest)</li>
                                                </ul>
                                            ),
                                            xdQaName: "Build Radius List Property Address",
                                        })}
                                    </div>
                                );
                            }
                        )}
                    </div>
                    <div className="form-group zip">
                        <div className="control-label" xd-qa-type="label" xd-qa-name="Build Radius List Zip Code">
                            Zip Code
                        </div>

                        {(() => {

                            const field = form.field(["zip"]);
                            return (
                                <input {...{
                                    placeholder: "90210",
                                    className: cx({hasError: field.error}),
                                    ...bindInput(field.state),
                                    "xd-qa-type": "text_field",
                                    "xd-qa-name": "Build Radius List Zip Code",
                                }}/>
                            );
                        })()}
                    </div>
                    <div className="form-group address-type">
                        <div className="control-label" xd-qa-type="label" xd-qa-name="Build Radius List Address Type">
                            Address Type
                        </div>

                        {(() => {
                            const field = form.field(["addressType"]);
                            return (
                                Select({
                                    forcedExpandLeft: true,
                                    list: [
                                        {
                                            label: "Single and Multi-Family",
                                            value: "both",
                                        },
                                        {
                                            label: "Single Family Only",
                                            value: "single",
                                        },
                                        {
                                            label: "Multi-Family Only",
                                            value: "multi",
                                        },
                                    ],
                                    itemToLabel: (e) => e?.label,
                                    onChange: (e) => field.state.onChange(e.value),
                                    isSelected: (e) => field.state.value == e.value,
                                    xdQaName: "Build Radius List Address Type"
                                })
                            );
                        })()}
                    </div>
                    <div className="form-group qty">
                        <div className="control-label" xd-qa-type="label" xd-qa-name="Build Radius List QTY">
                            QTY
                        </div>

                        {cs(
                            ["field", (_, next) => next(form.field(["quantity"]))],
                            ["focus", (_, next) => UseState({next})],
                            ["binding", ({field}, next) => NumberInputBinding({
                                state: field.state,
                                next,
                            })],
                            ({focus, binding, field}) => (
                                <div className={cx("input", {focus: focus.value, hasError: field.error})}>
                                    <input {...{
                                        ...binding,

                                        placeholder: "25",
                                        onFocus: () => focus.onChange(true),
                                        onBlur: () => {
                                            binding.onBlur();
                                            focus.onChange(false);
                                        },
                                    }}
                                           xd-qa-type="text_field"
                                           xd-qa-name="Build Radius List QTY"
                                    />

                                    {InformationBadge({
                                        getTooltip: () => "Enter the number of addresses you want included in this list. Please note that the quantity adjusts the cost of your list.",
                                        xdQaName: "Build Radius List QTY",
                                    })}
                                </div>
                            )
                        )}
                    </div>
                    <div className="form-group exclude-target-address">
                        <div className="label" xd-qa-type="label" xd-qa-name="Exclude Target Address">
                            Exclude target address from search results?
                        </div>
                        <div className="checkbox">
                            {SliderCheckbox({
                                ...form.field(["excludeTargetAddress"]).state,
                                xdQaName: "Exclude Target Address",
                            })}
                        </div>
                        <div className="target-address-tooltip">
                            {InformationBadge({
                                getTooltip: () => "Provide house number and apartment number with property address to avoid excluding multiple addresses within the target building.",
                                xdQaName: "Excude Target Address Tooltip",
                            })}
                        </div>
                    </div>

                    <div className="action">
                        <button {...{
                            className: cx({disabled: !form.valid}),
                            disabled: searching,
                            onClick: form.submit,
                            "xd-qa-type": "button",
                            "xd-qa-name": "Build Radius List Search",
                        }}>
                            {searching ? (
                                "Searching..."
                            ) : (
                                "Search"
                            )}
                        </button>
                    </div>
                </div>
            )
        ),
    })
);